/*
// set
cookie('test', 'a')

// complex set - cookie(name, value, ttl, path, domain, secure)
cookie('test', 'a', 60*60*24, '/api', '*.example.com', true)

// get
cookie('test')

// destroy
cookie('test', '', -1)
*/
function cookie(name, value, ttl, path, domain, secure) {
  if (typeof window === 'undefined') return;

  if (arguments.length > 1) {
    /* eslint-disable no-return-assign */
    return document.cookie = "".concat(name, "=").concat(encodeURIComponent(value)).concat(!ttl ? '' : "; expires=".concat(new Date(+new Date() + ttl * 1000).toUTCString())).concat(!path ? '' : "; path=".concat(path)).concat(!domain ? '' : "; domain=".concat(domain)).concat(!secure ? '' : '; secure');
    /* eslint-enable */
  }

  return decodeURIComponent(("; ".concat(document.cookie).split("; ".concat(name, "="))[1] || '').split(';')[0]);
}

function hasCookieSupport() {
  try {
    var key = '___c'; // Try to set cookie

    cookie(key, '1');
    var valueSet = document.cookie.indexOf(key) !== -1; // Cleanup cookie

    cookie(key, '', -1);
    return valueSet;
  } catch (e) {
    return false;
  }
}
/**
 * Get a cookie value
 * @param  {string} name - key of cookie
 * @return {string} value of cookie
 */


var getCookie = cookie;
/**
 * Set a cookie value
 * @param {string} name  - key of cookie
 * @param {string} value - value of cookie
 * @param {string} days  - days to keep cookie
 */

var setCookie = cookie;
/**
 * Remove a cookie value.
 * @param {string} name  - key of cookie
 */

function removeCookie(name) {
  return cookie(name, '', -1);
}

export { hasCookieSupport, setCookie, getCookie, removeCookie };